import { TileSettingsTranslation } from 'locales/de/pages/tileSettings';

const en: TileSettingsTranslation = {
  title: 'Tilesettings',
  systemTiles: 'Systemtiles',
  defaultTiles: 'Predefined tiles',
  categoryIcon: 'Category Icon',
  defaultIcon: 'Default Icon',
  tooltips: {
    categoryIcon: 'Icon for the categories',
    defaultIcon: 'Icon which every user can use'
  },
  alerts: {
    successfulIconCreate: 'The default icon has been created.'
  }
};

export default en;
